package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.mystyBag.responseModels.StoredCardModel

data class StoredCardsUIState(
    val cards: List<StoredCardModel> = emptyList(),
    val isLoading: Boolean = false
)
